export const environment = {
    production: false,
    apiURL: "http://k8s-sparkciamstaginga-ee6821aa7b-1790525729.us-east-1.elb.amazonaws.com/api",
    loginApp: "https://sign-in-stage.deloitte.com",
    host: "http://k8s-sparkciamstaginga-ee6821aa7b-1790525729.us-east-1.elb.amazonaws.com",
    clientId: 'demo_app',
    oauth: {
        clientId: 'demo_app',
        issuer: "https://myaccess-stage.deloitte.com/am/oauth2/realms/root/realms/alpha"
    }
}